// NEW PROJECT - Main Library Index
// File: /home/user/captis-editor/src/index.ts

// Export the main Editor component
export { default as Editor } from "../components/Editor";
export type { EditorComponentProps } from "../components/Editor";

// Export the useEditor hook
export { useEditor } from "../hooks/useEditor";
export type {
    UseEditorConfig,
    EditorStores,
    CustomModules,
    DocumentContent,
    EditorMetadata,
    DictionaryStore,
    AbbreviationStore,
    CitationsStore,
    ImageStore,
    TableStore,
    CommentStore,
    CrossReferenceStore,
    CaptisLinkStore,
} from "../hooks/useEditor";

// Export types
export type {
    EditorProps,
    BaseEditorProps,
    LegacyEditorProps,
} from "../types/editor";

// Export any extensions that might be useful
// export { CustomObjectPlugin } from "../extensions/custom-object";
